export { default as funcUserAgent } from './funcUserAgent';
export { default as funcWindowResize } from './funcWindowResize';
export { default as funcScrollControl } from './funcScrollControl';
export { default as funcScrollAnchor } from './funcScrollAnchor';
export { default as funcNav } from './funcNav';
export { default as funcLoadImg } from './funcLoadImg';
export { default as classDistortion } from './classDistortion';
export { default as funcLoad } from './funcLoad';


export { default as comBgVideo } from './comBgVideo';

export { default as comFade } from './comFade';
export { default as comImgFade } from './comImgFade';
export { default as comParallax } from './comParallax';
// export { default as comSplitBg } from './comSplitBg';


// export { default as sampleDistortion } from './sampleDistortion';
// export { default as loadImgSample } from './loadImgSample';

// export { default as topMain } from './topMain';
export { default as topSwiper } from './topSwiper';
export { default as topAnime2 } from './topAnime2';
export { default as topLink } from './topLink';
export { default as topAir } from './topAir';
export { default as topVideo } from './topVideo';
export { default as planScroll } from './planScroll';


export { default as accessMapCircle } from './accessMapCircle';
export { default as accessAerial } from './accessAerial';
export { default as accessTxt } from './accessTxt';
export { default as accessSlide } from './accessSlide';
export { default as accessBicycle } from './accessBicycle';
export { default as lifeinfo } from './lifeinfo';

export { default as modal } from './modal';

export { default as funcEntry } from './funcEntry';

export { default as designSlide } from './designSlide';